import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const GeneralEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual do IDConselho"
            subtitles={chartData.general.map((item) => getYearLabel(item.ano))}
            values={chartData.general.map(
                (item) => Number(item.idconselho) || 0
            )}
        />
    );
};
